import NewsMasonryView from './NewsMasonryView.vue';
import NewsHeader from './NewsHeader.vue';
import NewsDetailView from './NewsDetailView.vue';
import moduleId from './moduleId';

class NewsRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/news/:instance',
        name: 'news',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: NewsMasonryView, header: NewsHeader },
      },

      {
        path: '/news/:instance/:itemId',
        name: 'news-item',
        meta: {
          backPath: (currentRouteParams) => {
            return `/news/${currentRouteParams.instance}`;
          },
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: false,
          isRouterViewFixed: true,
        },
        components: { default: NewsDetailView, header: NewsHeader },
      },
      {
        path: '/news/:instance/:itemId/:attachementId',
        name: 'news-item-attachement',
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: false },
        components: { default: NewsDetailView, header: NewsHeader },
      },
    ];
  };
}
const routeHandler = new NewsRouteHandler();
export default routeHandler;
